import { useI18n } from '@/shared/i18n/I18nProvider'

/**
 * THE SMARTOMICA LOCKUP — sign and wordmark together, in the arrangement
 * `smartomica_brand_guide.docx` fixes and in no other.
 *
 * TWO SOURCES, ONE DRAWING, and which file each half comes from is the whole
 * of this module's history. The sign is `smartomicaMark.svg`, the vendor's own
 * vector, which the guide's export proves is the guide's sign. The wordmark is
 * `smartomicaWordmark.png`, the alpha of the guide's own lockup export: the
 * name is set in a face this repository does not have — the guide's glyphs run
 * 9% narrower and 4% taller than the vendor web file's, so they are a
 * different cut — and the `®` §1.6 requires appears in no vector here at all.
 * Re-setting the name or tracing it into a polygon of our own is what §1.7
 * calls changing the typeface, so the guide's own pixels are what this product
 * draws. `branding.css` says why the raster is safe at every size used.
 *
 * What stood here before was `/smartomica.svg` as served by the vendor's
 * Clinical Synopsis Engine — a 153×40 lockup with no `®` and a narrower gap,
 * clipped into two halves of one file. It is not the guide's lockup, and by
 * operator decision the guide is what this product wears.
 *
 * TWO LAYERS, because the guide paints the two halves differently: the sign
 * keeps its cyan-to-blue gradient in both schemes and only the wordmark
 * follows the ground. Each layer masks its own file, so neither is clipped out
 * of the other and the sign's gradient runs its full ramp across the sign.
 *
 * DECORATIVE BY CONSTRUCTION: the drawing hides from the tree, and the vendor's
 * name stands beside it as hidden text so a reader who cannot see the wordmark
 * still hears whose surface this is.
 */
export function SmartomicaLogo() {
  const { t } = useI18n()
  return (
    <span className="smartomica-logo">
      <span className="smartomica-logo__image" aria-hidden="true">
        <span className="smartomica-logo__mark" />
        <span className="smartomica-logo__wordmark" />
      </span>
      <span className="visually-hidden">{t('externalModule.smartomica.navLabel')}</span>
    </span>
  )
}
